<template>
  <div class="broadcast-container">
    <div class="top-section">
      <span class="title">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_TITLE') }} {{ broadcastInfoData.name }}</span>
      <span class="icon" @click="closeBroadcastView"><i class="fas fa-times"></i></span>
    </div>
    <div class="form-section">
      <div class="recipients">
        <div class="platform">
          <div>
            <span>{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_PLATFORM') }}</span>
            <select v-model="data.platform" @change="setTemplates"
              :class="{ 'error': showErrors && data.platform === null }">
              <option disabled selected>{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_SELECT_PLATFORM') }}</option>
              <option v-for="platform in broadcastInfoData.platforms" :value="platform.id" :key="platform.id">
                {{ platform.name }}
              </option>
            </select>
          </div>
          <div v-if="showTemplates" class="templates">
            <span>{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_TEMPLATE') }}:</span>
            <select v-model="template" @change="changeTemplate"
              :class="{ 'error': showErrors && data.template === null }">
              <option v-for="template in templates" :key="template.id" :value="template">{{ template.name }}</option>
            </select>
          </div>
        </div>
        <div class="last-connection">
          <span>{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_LAST_MESSAGE_USER') }}</span>
          <input type="date" v-model="data.dateFrom" @change="updateUsersCount"/>
          <span>hasta</span>
          <input type="date" v-model="data.dateTo" @change="updateUsersCount"/>
        </div>
        <span v-if="broadcastInfoData.parameters">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_OTHER_PARAMETERS') }}</span>
        <div v-if="broadcastInfoData.parameters" class="attributes-section">
          <div class="attribute" v-for="attribute in broadcastInfoData.parameters" :key="attribute.id">
            <span class="attribute-name">{{ attribute.name }}:</span>
            <div class="options">
              <span v-for="option in attribute.options" :key="option.id">
                <label :for="option.id">{{ option.name }}</label>
                <input type="checkbox" :name="option.id" :id="option.id"
                  :value="{ idParameter: attribute.id, idValue: option.id }" v-model="data.parameters"
                  @change="updateUsersCount">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="message">
          <span class="title">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_MESSAGE') }}:</span>
          <textarea rows="12" cols="65" v-model="data.message" :disabled="showTemplates && template"
                    v-bind:placeholder="CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_WRITE_MESSAGE') " @focus="sentencePosition=0" id="broadcastMessage"></textarea>
        </div>
        <div class="additional">
          <div class="is-flex-row-center buttons" v-if="!isWhatsappSelected">
            <div class="button" :class="{ 'is-primary': showEmojis }"
              @click="showEmojis = !showEmojis; showAddFile = false">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_BUTTON_EMOJI') }}</div>
          </div>
          <div class="emojis-container" v-if="!isWhatsappSelected">
            <emojis v-if="showEmojis" @emoji-selected="addElement"></emojis>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-section">
      <div class="users-count">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_SEND_MESSAGE_1') }}
        {{ usersCount }}  {{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_SEND_MESSAGE_2') }}
      </div>
      <div class="button is-primary">
        <span @click="sendBroadcast">{{ CONSTANTS.getCopy('BROADCASTMESSAGES_CHATS_SEND_BROADCAST') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Emojis from '../templates/Emojis'
import Answers from '../../lib/AnswersMethods'
import CONSTANTS from '../../constants'

export default {
  components: { Emojis },
  props: { client: String },
  data () {
    return {
      data: {
        idClient: this.client,
        message: '',
        dateFrom: null,
        dateTo: null,
        platform: null,
        template: null,
        parameters: []
      },
      broadcastInfoData: null,
      showTemplates: false,
      templates: [],
      template: null,
      attributes: [],
      usersCount: 0,
      isWhatsappSelected: false,
      showErrors: false,
      showEmojis: false,
      showAddFile: false,
      sentencePosition: 0,
      fileRoute: null,
      fileName: null
    }
  },
  created () {
    this.getBroadcastInfoData()
  },
  methods: {
    closeBroadcastView () {
      this.$emit('closeBroadcastView')
    },
    sendBroadcast () {
      this.showErrors = true
      this.data.template = this.template ? this.template.name : null
      if (this.checkFields()) {
        let message = CONSTANTS.getCopy('BROADCASTMESSAGES_CONFIRM_SEND_BROADCAST')
        this.dialog.confirm({ message }).then(() => {
          this.dialog.confirmCountdown().then(() => {
            this.data.message = this.template ? this.template.messageOriginal : this.data.message
            this.api.post('/BroadcastSend', this.data)
            this.$emit('closeBroadcastView')
          })
        })
      }
    },
    getBroadcastInfoData () {
      this.api.post('/BroadcastGetInfo', { idClient: this.client }).then((response) => {
        this.broadcastInfoData = response.bots[0]
        this.getPlatforms()
      })
    },
    getPlatforms () {
      this.broadcastInfoData.platforms.forEach(element => {
        if (element.name === 'Whatsapp') {
          element.templates.forEach(template => {
            this.templates.push(template)
          })
        }
      })
    },
    setTemplates () {
      this.showTemplates = this.data.platform === 'W'
      this.isWhatsappSelected = true
      this.showAddFile = true

      if (!this.showTemplates) {
        this.data.message = ''
        this.template = null
        this.isWhatsappSelected = false
        this.showAddFile = false
        this.updateUsersCount()
      }
    },
    changeTemplate () {
      this.data.message = this.template.message
      this.updateUsersCount()
    },
    updateUsersCount () {
      this.data.template = this.template ? this.template.name : null
      if (this.checkFields()) {
        this.api.post('/BroadcastTotalUsers', this.data).then((response) => {
          this.usersCount = response.total
        })
      }
    },
    checkFields () {
      return this.showTemplates
        ? this.data.platform && this.data.template
        : this.data.platform
    },
    setFile (e) {
      let files = e.target.files

      if (!files.length) {
        this.fileName = null
        return
      }

      this.fileName = files[0].name
    },
    addElement (syntax) {
      let data = Answers.addElement(syntax, this.data.message, this.sentencePosition, `#broadcastMessage`)
      this.data.message = data.sentence
      this.sentencePosition = data.position
      this.$forceUpdate()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Chats/BroadcastMessages.vue